import { h } from "@stencil/core";

const CloseButton = () => (
<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.25861 10.9543C1.08083 10.9543 0.962312 10.895 0.843793 10.7765C0.606756 10.5394 0.606756 10.1839 0.843793 9.94686L10.3253 0.465375C10.5623 0.228338 10.9179 0.228338 11.1549 0.465375C11.3919 0.702412 11.3919 1.05797 11.1549 1.295L1.67342 10.7765C1.5549 10.895 1.43639 10.9543 1.25861 10.9543Z" fill="#141618"/>
  <path d="M10.7401 10.9543C10.5623 10.9543 10.4438 10.895 10.3253 10.7765L0.843793 1.295C0.606756 1.05797 0.606756 0.702412 0.843793 0.465375C1.08083 0.228338 1.43639 0.228338 1.67342 0.465375L11.1549 9.94686C11.3919 10.1839 11.3919 10.5394 11.1549 10.7765C11.0364 10.895 10.9179 10.9543 10.7401 10.9543Z" fill="#141618"/>
</svg>
);

export default CloseButton;
